import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function getDashboard() {
  return $apiClient.get(`${ApiConfig.DASHBOARD}`);
}
